import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';



const ReporteCurso=({ id, ajaxCallInProgress, errors=[],reporte, cambiarEstatus, strings, cursoCombo, onChange, inscripcion, download, constancia, resultadosExamen, onShowAvance})=>{

	return (
        <Container>
          
            <Segment>
                    <Form>
                         <Form.Field >            
                              <label  >{strings?strings["busqueda"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["empresa"]:""} 
                                    name="emp"
                                    onChange={onChange}
                                    value={reporte.emp}
                                    icon='edit'/>
                            </Form.Field>
                    </Form>    
            </Segment>
        {inscripcion.inscripcion.length>0?
       
            
                <Container>
         
                    <Segment clearing>
                        <Header floated='left'>
                           Alumnos inscritos: {inscripcion.inscripcion.length}
                        </Header>
                        <Header floated='right'>
                          reporte<Icon color="green" size="small" link onClick={download} name='file excel' />
                        </Header>
        
        
                      </Segment>
         
                    <Table celled>
                        <Table.Header>
                        <Table.Row>
                            
                                <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["profesion"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["pais"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["telefono"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["modulosVistos"]:""}</Table.HeaderCell>
        
        
                              
        
                                <Table.HeaderCell textAlign="center">{strings?strings["constancia"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["estatus"]:""}</Table.HeaderCell>
    
                        
                        </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            
                            {inscripcion.inscripcion.map(alumno =>
                            
                            <Table.Row>
                                    <Table.Cell>
                                        {alumno.usuario}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {alumno.profesion}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {alumno.mail}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.pais}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.empresa}
                                    </Table.Cell>    
                                    <Table.Cell textAlign="right">
                                        {alumno.telefono}
                                    </Table.Cell>    
                                    <Table.Cell textAlign="center">
                                    {((Number(alumno.modulosVistos)*100)/Number(inscripcion.modulos)).toFixed(0)}%
                            
                                                    <Popup
                                                        trigger={
                                                            <Icon name='eye' link 
                                                            onClick={()=>onShowAvance(alumno.idUsuario)} 
                                                            size="large" color="blue"  />
                                                                
                                                            
                                                        }
                                                        content={((Number(alumno.modulosVistos)*100)/Number(inscripcion.modulos)).toFixed(0)+"%"}
                                                      />
        
        
        
                                    </Table.Cell>
                                    
                                   
                                    
                                    
                                    
                                    
                                    <Table.Cell textAlign="center">
                                        <List horizontal>
                                           
                                            <List.Item>
                                                {alumno.emisionConstancia==null?
                                            
                                                <Popup
                                                    trigger={
                                                        <Icon name='id card' link 
                                                       
                                                        size="large" color={alumno.finalizado==0?"green":"red"} 
                                                        onClick={()=>constancia(alumno.id)} />
                                                    }
                                                    content={alumno.finalizado==0?'Permitir emisión de constancia':'Denegar emisión de constancia'}
                                                  />
                                                 
                                                :
                                                  
                                                    <Popup
                                                    trigger={
                                                        <Icon name='id card' link 
                                                       
                                                        size="large" color={"orange"}/>
                                                    }
                                                    content={"Constancia emitida el : "+ alumno.emisionConstancia}
                                                  />
                                                
                                                
                                                }  
                                            </List.Item>
                                        </List>
                                    </Table.Cell>
                            
                                    <Table.Cell textAlign="center">
                                        <List horizontal>
                                            <List.Item>
                                            {alumno.idEstatus==1?
                                                <Popup
                                                    trigger={
                                                        <Icon name='check' link 
                                                        size="large" color="green" 
                                                        onClick={()=>cambiarEstatus(alumno.id)} />
                                                    }
                                                    content={'Da click para inactivar'}
                                                  />
                                                        :
                                                <Popup
                                                    trigger={
                                                        <Icon name='times' link 
                                                        size="large" color="red" 
                                                        onClick={()=>cambiarEstatus(alumno.id)} />
                                                    }
                                                    content={'Da click para activar'}
                                                  />
                                                }
                                            </List.Item>
                                        </List>
                                    </Table.Cell>
                                  
                            </Table.Row>    
                            
                            )}
                             
                        </Table.Body>    
                    </Table>
        
        
        
                </Container>
        
                :
        
                "Seleccióne un curso"
        
            }        
        
        
        </Container>
	);
};



export default ReporteCurso;